import { Component } from '@angular/core';

@Component({
    selector: 'app-home-assinatura',
    templateUrl: './_assinatura.component.html',
    styleUrls: ['./_assinatura.component.css']
})

export class Home_AssinaturaComponent {
}
